module.exports = __webpack_public_path__ + "static/42-8660da47117b53b1ab977cd7c56b9aa3.jpg";